import axios from 'axios';
import { GETSITEMAP } from '../index';

export const getSitemapApi = (postData) => {
  return axios.post(GETSITEMAP, JSON.stringify(postData));
};
